import * as p from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/NewspaperClipping.es.js";
const e = p.forwardRef((o, r) => /* @__PURE__ */ p.createElement(a, { ref: r, ...o, weights: i }));
e.displayName = "NewspaperClippingIcon";
const n = e;
export {
  n as NewspaperClipping,
  e as NewspaperClippingIcon
};
